import {HttpResponse, HttpService} from "./http.service";

export const SubscriptionPlanService = {
    async sendSubscriptionRequest(name: string) {
        const response: HttpResponse<any> = await HttpService.post('subscription-plan/send_subscription_request/?plan_codename=' + name, {});

        return response.status;
    },
    async newSendSubscriptionRequest(planName: string, paymentMethod: 'online' | 'manual') {
        const data = {
            payment_method: paymentMethod,
            plan_codename: planName
        };

        const response: HttpResponse<any> = await HttpService.post('payments/new/', data);
        return response;
    }
}
